import { isDefined } from "@clipboard-health/util-ts";
import { Button, type SxProps, type Theme } from "@mui/material";
import { useHistory } from "react-router-dom";

import { getLocation } from "../../utils/routes";
import type { AdminChatMessage } from "../types";
import { parseGroupShiftInviteCount } from "../utils/parseShiftInviteMessage";
import { ChatMessageCard } from "./ChatMessageCard";

interface GroupShiftInviteRequestMessageProps {
  message: AdminChatMessage;
  sx?: SxProps<Theme>;
}

/**
 * Renders a group shift invite message with "View calendar" button.
 * Shown when multiple shift invites are sent at once.
 */
export function GroupShiftInviteRequestMessage(props: GroupShiftInviteRequestMessageProps) {
  const { message, sx } = props;
  const history = useHistory();

  const numberOfInvites = parseGroupShiftInviteCount(message.data, message.message);

  const title = isDefined(numberOfInvites)
    ? `You sent ${numberOfInvites} shift invites`
    : "You sent multiple shift invites";

  const handleViewCalendar = () => {
    history.push(getLocation("facilityDashboard"));
  };

  return (
    <ChatMessageCard
      actions={
        <Button size="small" variant="contained" onClick={handleViewCalendar}>
          View calendar
        </Button>
      }
      sx={sx}
      title={title}
    />
  );
}
